// extracted by mini-css-extract-plugin
export default {"mainContainer":"owners_section-module___mainContainer___e62fe428","ownersContainer":"owners_section-module___ownersContainer___c2afda48"};